import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    height: "500px",
    flexGrow: 1,
  },
  stepComponent: {
    marginLeft: theme.spacing.unit*3,
    marginRight: theme.spacing.unit*3,
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  actions: {
    marginTop: theme.spacing.unit*4,
  },
});


class ImportStepper extends React.Component {
  state = {
    activeStep: 0,
    skipped: new Set(),
  };

  handleNext = () => {
    const { steps, onClose } = this.props;
    const { activeStep } = this.state;
    let { skipped } = this.state;
    if( activeStep === steps.length - 1) {
      onClose();
    } else {
      if (this.isStepSkipped(activeStep)) {
        skipped = new Set(skipped.values());
        skipped.delete(activeStep);
      }
      this.setState({
        activeStep: activeStep + 1,
        skipped,
      });
    }
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleSkip = () => {
    const { steps } = this.props;
    const { activeStep } = this.state;
    if (!steps[activeStep].isOptional) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  render() {
    const { classes, steps } = this.props;
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <Tooltip type={TooltipTypes.IMPORT_TIME_MATERIALS_PROGRESS} placement="top">
            <Stepper activeStep={activeStep}>
              {steps.map((step, index) => {
                const label = step.label;
                const props = {};
                const labelProps = {};
                if (step.isOptional) {
                  labelProps.optional = <Typography variant="caption">Optional</Typography>;
                }
                if (this.isStepSkipped(index)) {
                  props.completed = false;
                }
                return (
                  <Step key={label} {...props}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Tooltip>
          <div className={classes.stepComponent}>
            {steps[activeStep].content}
          </div>

        </div>
        <div className={classes.actions}>
          <Button
            disabled={activeStep === 0}
            onClick={this.handleBack}
            className={classes.button}
          >
            Back
          </Button>
          {steps[activeStep].isOptional && (
            <Tooltip type={TooltipTypes.IMPORT_MATERIALS_SKIP} placement="top">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.handleSkip();
                  helpDispatch();
                }}
                className={classes.button}
              >
                Skip
              </Button>
            </Tooltip>
          )}
          {activeStep !== steps.length - 1 &&
            <Tooltip type={TooltipTypes.IMPORT_TIME_NEXT} placement="top">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.handleNext();
                  helpDispatch();
                }}
                className={classes.button}
              >
                Next
              </Button>
            </Tooltip>
          }
          {activeStep === steps.length - 1 &&
            <Tooltip type={TooltipTypes.IMPORT_TIME_MATERIALS_FINISH} placement="top">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.handleNext();
                  helpDispatch();
                }}
                className={classes.button}
              >
                Finish
              </Button>
            </Tooltip>
          }
        </div>
      </div>
    );
  }
}

ImportStepper.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(ImportStepper);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/ImportStepper.jsx